import React from 'react';
import ProductCatalogPanel from '@/temu-platform/modules/products/components/ProductCatalogPanel';

export default function ProductListPage() {
  return <ProductCatalogPanel mode="catalog" showStatusTabs />;
}
